export default __webpack_public_path__ + "static/media/banner-accessories.bdd2e0fc.png";